import MaskedView from "@react-native-masked-view/masked-view";
import React, { useState } from "react";
import { LinearGradient } from "expo-linear-gradient";
import LButton, { ButtonProps } from "./LButton";
import LPressable from "./LPressable";

type Props = ButtonProps & {
  gradient?: string[];
};

const GradientButton = ({ enabled = true, gradient, ...rest }: Props) => {
  const [loading, setLoading] = useState(false);
  const handlePress = async () => {
    setLoading(true);
    await rest.onPress();
    setLoading(false);
  };

  return (
    <LPressable
      sentryEventName={`gradient_button_${rest.label}`}
      onPress={handlePress}
      disabled={!enabled || loading}
      accessibilityLabel={rest.accessibilityLabel ?? rest.label}
      testID={rest.testID}
      style={{
        opacity: !enabled || loading ? 0.5 : 1,
      }}
      fadeEnabled
    >
      <MaskedView maskElement={<LButton {...rest} />}>
        <LinearGradient
          colors={gradient || ([] as any)}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
        >
          <LButton {...rest} opacity={0} />
        </LinearGradient>
      </MaskedView>
    </LPressable>
  );
};

export default GradientButton;
